import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app-routing.module';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { headerInterceptor } from './services/header.interceptor';
export const appConfig: ApplicationConfig = {
    providers: [provideRouter(routes,), provideClientHydration(), provideAnimations(), provideHttpClient(withInterceptorsFromDi(),
        withInterceptors([headerInterceptor]),), provideAnimationsAsync()]
};